import React, { useEffect, useState, useRef } from 'react';

import { Card, Button, Modal, Form, InputGroup } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import LocaleHandler from '../../../LocaleHandler';
import 'react-toastify/dist/ReactToastify.css';
import './Users.scss';
import PageTable from '../../Shared/PageTable/PageTable';
import FilterSelector from '../../Shared/FilterSelector/FilterSelector';
import DateFormatter from '../../Shared/DateFormatter/DateFormatter';
import Field from '../../Shared/Wizard/Field/Field';


function Users(props) {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const { setLocale } = React.useContext(LocaleHandler)
    const myRef = useRef<any>();

    const userName = t("users.user");
    const role = t("users.new_role");
    const orgRole = t("users.new_orgrole");
    const email = t("users.new_email");
    const mobile = t("users.new_mobile");
    const created = t("users.created");
    const invoicingUserId = t("users.new_invoicing_user_id");

    const [orgs, setOrgs] = useState([]);

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [editUser, setEditUser] = useState({
        name: "",
        unit: [""],
        email: "",
        phone: "",
        role: "",
        orgRole: "",
        language: "",
        ExternalAccess: [],
        customfields: [{}],
        invoicingUserId: "",
    } as any);

    const [deleteUser, setDeleteUser] = useState({
        name: "",
        unit: [""],
        email: "",
        phone: "",
        role: "",
        orgRole: "",
        language: "",
        invoicingUserId: "",
    });

    const [usersFilter, setUsersFilter] = useState([]);

    const setEditUserName = value => { setEditUser(editUser => ({ ...editUser, name: value })); }
    const setEditUserUnit = value => { setEditUser(editUser => ({ ...editUser, unit: [value] })); }
    const setEditUserEmail = value => { setEditUser(editUser => ({ ...editUser, email: value })); }
    const setEditUserPhone = value => { setEditUser(editUser => ({ ...editUser, phone: value })); }
    const setEditUserPassword = value => { setEditUser(editUser => ({ ...editUser, password: value })); }
    const setEditUserLanguage = value => { setEditUser(editUser => ({ ...editUser, language: value })); }
    const setEditUserRole = value => { setEditUser(editUser => ({ ...editUser, role: [value] })); }
    const setEditUserOrgRole = value => { setEditUser(editUser => ({ ...editUser, orgRole: [value] })); }
    const setEditUserExternalAccess = value => { setEditUser(editUser => ({ ...editUser, externalAccess: value })); }
    const setEditUserInvoicingUserId = value => { setEditUser(editUser => ({ ...editUser, invoicingUserId: value })); }

    const [newuserName, setNewUserName] = useState("");
    const [newunit, setNewUnit] = useState("");
    const [newrole, setNewRole] = useState("");
    const [newOrgRole, setNewOrgRole] = useState("");
    const [newemail, setNewEmail] = useState("");
    const [newpassword, setNewPassword] = useState("");
    const [newphone, setNewPhone] = useState("");
    const [newlanguage, setNewLanguage] = useState("no");
    const [newExternalAccess, setNewExternalAccess] = useState<Array<String>>([]);
    const [newInvoicingUserId, setNewInvoicingUserId] = useState("");
    
    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [updateTable, setUpdateTable] = useState(0);

    const [events, setEvents] = useState<Array<any>>([]);
    
    function handleClose() {
        setShow(false);
        cleanNewForm();
    }

    const handleCloseEditModal = () => setShowEditModal(false);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);
    const handleShow = () => {
        setNewUnit(orgs[0]["_id"]);
        setShow(true);
    }

    const handleShowEditModal = (dataLine, evt) => {
        setEditUser(dataLine);
        setShowEditModal(true);
    };

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setDeleteUser(dataLine);
        setShowDeleteModal(true);
    };

    const updateNewUserName = event => setNewUserName(event.target.value);
    const updateNewUnit = event => setNewUnit(event.target.value);
    const updateNewEmail = event => setNewEmail(event.target.value);
    const updateNewPassword = event => setNewPassword(event.target.value);
    const updateNewPhone = event => setNewPhone(event.target.value);
    const updateNewLanguage = event => setNewLanguage(event.target.value);
    const updateNewRole = event => setNewRole(event.target.value);
    const updateNewOrgRole = event => setNewOrgRole(event.target.value);
    const updateNewInvoicingUserId = event => setNewInvoicingUserId(event.target.value);

    // Empty the form after creating a new user.
    function cleanNewForm() {
        setNewUserName("");
        setNewUnit(orgs[0]["_id"]);
        setNewRole("");
        setNewOrgRole("");
        setNewEmail("");
        setNewPassword("");
        setNewPhone("");
        setNewLanguage("");
        setNewInvoicingUserId("");
        setNewExternalAccess([]);
    }

    function handleCreateUser() {
        //required fields validation
        if (newuserName == "") { notifyWarning(t("users.toast_users_empty_name")); return undefined; }
        if (newunit == "") { notifyWarning(t("users.toast_users_empty_unit")); return undefined; }
        if (newrole == "") { notifyWarning(t("users.toast_users_empty_role")); return undefined; }
        if (newOrgRole == "") { notifyWarning(t("users.toast_users_empty_orgrole")); return undefined; }
        //if (newemail == "") { notifyWarning(t("users.toast_users_empty_email")); return undefined; }
        
        if (newemail !== "undefined") {
            let pattern = new RegExp(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/);
            if (!pattern.test(newemail)) {
                notifyWarning(t("users.toast_users_invalid_email"));
                return undefined;
            }
        }
        
        if (newpassword == "") { notifyWarning(t("users.toast_users_empty_password")); return undefined; }
        
        axios.post(
            "/api/users",
            {
                name: newuserName,
                email: newemail,
                role: newrole,
                orgRole: newOrgRole,
                unit: newunit,
                password: newpassword,
                phone: newphone,
                language: newlanguage,
                invoicingUserId: newInvoicingUserId,
                externalAccess: newExternalAccess,
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            cleanNewForm();
            fetchData();
            notifySuccess(t("users.toast_users_created"));
            handleClose();
            setUpdateTable(updateTable + 1);
        });
    }

    function handleEditUser() {
        //required fields validation
        if (editUser["name"] == "") { notifyWarning(t("users.toast_users_empty_name")); return undefined; }
        //if (editUser["email"] == "") { notifyWarning("Please enter valid email address."); return undefined; }
        if (editUser["unit"] == "") { notifyWarning(t("users.toast_users_empty_unit")); return undefined; }
        if (editUser["role"] == "") { notifyWarning(t("users.toast_users_empty_role")); return undefined; }
        if (editUser["orgRole"] == "") { notifyWarning(t("users.toast_users_empty_orgrole")); return undefined; }
        //if (editUser["email"] == "") { notifyWarning(t("users.toast_users_empty_email")); return undefined; }
        //if (editUser["password"] == "") { notifyWarning(t("users.toast_users_empty_password")); return undefined; }
        
        if (editUser["email"] !== "undefined") {
            // let pattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
            let pattern = new RegExp(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/);
            
            if (!pattern.test(editUser["email"])) {
                notifyWarning(t("users.toast_users_invalid_email"));
                return undefined;
            }
        }
        

        axios.put(
            "/api/users/" + editUser["_id"],
            {
                name: editUser["name"],
                email: editUser["email"],
                role: editUser["role"],
                orgRole: editUser["orgRole"],
                unit: editUser["unit"],
                password: editUser["password"] != "" ? editUser["password"] : undefined,
                phone: editUser["phone"],
                language: editUser["language"],
                invoicingUserId: editUser["invoicingUserId"],
                externalAccess: editUser["externalAccess"],
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            let localUser = localStorage.getItem("user");
            if (localUser != null && editUser["_id"] == JSON.parse(localUser)["userdata"]["_id"]) {
                let localUserdata = localUser != null ? JSON.parse(localUser) : {};
                if (localUserdata != null) {
                    localUserdata["userdata"] = res.data;
                    localStorage.setItem("user", JSON.stringify(localUserdata));
                }
            }
            setLocale(res.data["language"].toLowerCase());
            fetchData();
            handleCloseEditModal();
            setUpdateTable(updateTable + 1);
        });
    }

    function handleDeleteUser() {
        axios.delete(
            "/api/users/" + deleteUser["_id"],
            {},
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            fetchData();
            notifySuccess(t("users.toast_users_deleted"));
            handleCloseDeleteModal();
            setUpdateTable(updateTable + 1);
        });
    }

    const handleKeyDownCreate = event => {
        if (event.key === 'Enter') {
            handleCreateUser();
        }
    }

    const handleKeyDownEdit = event => {
        if (event.key === 'Enter') {
            handleEditUser();
        }
    }

    async function fetchData() {
        axios.all([
            axios.single({
                method: "get",
                url: "/api/orgelements",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/filters",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/events/",
                responseType: "json",
                headers: {'x-access-token': auth.user["token"]}
            }),
        ])
            .then(axios.spread((...res) => {
                setOrgs(res[0].data);
                setEvents(res[2].data?.map(x => {return { value: x._id, label: x.name } }));
            }))
            .catch(err => console.log(err));
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
        fetchData();
    }, []);

    return (
        <div className="maincontent">
            <div className="users-container">
                <Card>
                    <Card.Body>
                        <h4 className="header-title">{t("users.title")}</h4>
                        {auth.user["userdata"]["role"][0] === "Admin" &&
                            <Button className="newuserBtn" onClick={handleShow}>{t("users.new")}</Button>
                        }
                        <br />
                        <p>{t("users.filters")}</p>
                        <FilterSelector
                            filtersUrl="/api/filters/bytype/"
                            filterType="user"
                            fields={[
                                { label: userName, value: "name", type: "string" },
                                { label: role, value: "role", type: "string" },
                                { label: orgRole, value: "orgRole", type: "string" },
                                { label: email, value: "email", type: "string" },
                                { label: mobile, value: "phone", type: "string" },
                                { label: created, value: "date", type: "date" },
                            ]}
                            onChange={(filter) => {
                                setUsersFilter(filter.filters);
                            }}
                            onAddClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                            onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                            onDeleteClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                            addFilterText={t("general.addfilter")}
                        ></FilterSelector>
                        <PageTable
                            dataUrl="/api/users/getAllPaged/"
                            options={{
                                showFields: [
                                    { label: userName, field: "name" },
                                    {
                                        label: role, 
                                        field: "role", 
                                        override: dataLine => dataLine["role"] != undefined ?
                                            dataLine["role"] == "Admin" ? t("users.admin") :
                                                dataLine["role"] == "User" ? t("users.user") : ""
                                            : "",
                                        customFilters: [
                                            { value: "User", label: t("users.user") },
                                            { value: "Admin", label: t("users.admin") }
                                        ]
                                    },
                                    {
                                        label: orgRole, 
                                        field: "orgRole", 
                                        override: dataLine => {
                                            if (dataLine["orgRole"] != undefined) {
                                                switch (dataLine["orgRole"] instanceof Array ? dataLine["orgRole"][0] : dataLine["orgRole"]) {
                                                    case "cleaningstaff": return (t("users.cleaningstaff"))

                                                    case "janitor": return (t("users.janitor"))

                                                    case "systemTech": return (t("users.systemtech"))
                                                    
                                                    case "external": return (t("users.external"))
                                                    
                                                    default:
                                                        return ("")


                                                }
                                            }
                                        },
                                        customFilters: [
                                            { value: "cleaningstaff", label: t("users.cleaningstaff")},
                                            { value: "janitor", label: t("users.janitor")},
                                            { value: "systemTech", label: t("users.systemtech")},
                                        ]
                                    },
                                    { label: email, field: "email" },
                                    { label: mobile, field: "phone" },
                                    {   
                                        label: created, 
                                        field: "date", 
                                        override: (dataLine) => dataLine.date != undefined ? <DateFormatter date={dataLine.date} /> : "",
                                        noFilter: ""
                                    },
                                ]
                            }}
                            dataAfter={(dataLine) =>
                                auth.user["userdata"]["role"] == "Admin" && auth.user["userdata"]["_id"] != dataLine["_id"] ?
                                    <Button onClick={(evt) => handleShowDeleteModal(dataLine, evt)}> {t("users.delete")} </Button>
                                    : null
                            }
                            onLineClick={handleShowEditModal}
                            hidePagination={false}
                            hidePagesize={false}
                            hideFilter={false}
                            updateTable={updateTable}
                            hover={true}
                            permaFilters={usersFilter}
                        /*permaFilters={[
                            { field: "date", type: "to", modifier: "moment-add-hours", values: ["2"] },
                            { field: "date", type: "from", modifier: "moment-remove-hours", values: ["6"] },
                            { field: "date", type: "to", values: ["2021-01-06T20:24:30.000Z"] },
                            { field: "name", type: "and", values: [""] },
                        ]}*/
                        />
                    </Card.Body>
                </Card>

                {/* New Modal */}
                <Modal show={show} onHide={handleClose} onEntered={() => myRef.current.focus()}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("users.new_title")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_name")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_name")} ref={myRef} onChange={updateNewUserName} value={newuserName} onKeyDown={handleKeyDownCreate} ></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_unit")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onChange={updateNewUnit} value={newunit} onKeyDown={handleKeyDownCreate}>
                                {/*<option value="">{t("users.organisation_selected")}</option>*/}
                                {
                                    orgs.map((item, key) => {
                                        return (
                                            <option key={key} value={item["_id"]}>{item["name"]}</option>
                                        );
                                    })
                                }
                            </Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_role")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onKeyDown={handleKeyDownCreate} onChange={updateNewRole} >
                                <option value="">{t("users.roles_choose")}</option>
                                <option value="Admin">{t("users.admin")}</option>
                                <option value="User">{t("users.user")}</option>
                            </Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_orgrole")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onKeyDown={handleKeyDownCreate} onChange={updateNewOrgRole} >
                                <option value="">{t("users.orgroles_choose")}</option>
                                <option value="cleaningstaff">{t("users.cleaningstaff")}</option>
                                <option value="janitor">{t("users.janitor")}</option>
                                <option value="external">{t("users.external")}</option>
                                {newrole === "Admin" &&
                                    <option value="systemTech">{t("users.systemtech")}</option>
                                }
                            </Form.Control>
                        </InputGroup>
                        { newOrgRole == "external" ?
                            <React.Fragment>
                                <Field type="selectmulti"
                                    title={t("users.events")}
                                    value={newExternalAccess?.map(x => { return { value: x, label: events.find(y => y.value == x)?.label }})}
                                    options={{ choices: events }}
                                    onChange={(value) => setNewExternalAccess(value.map(x => x.value))}
                                />
                                <p style={{
                                    marginTop: "-16px",
                                    fontSize: "14px",
                                    textAlign: "right"
                                }}>{t("users.events_accesstext")}</p>
                            </React.Fragment>
                        : null }
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_email")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_email")} onChange={updateNewEmail} value={newemail} onKeyDown={handleKeyDownCreate}></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_password")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="password" autoComplete="new-password" placeholder={t("users.new_password")} onChange={updateNewPassword} value={newpassword} onKeyDown={handleKeyDownCreate}></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_mobile")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_mobile")} onChange={updateNewPhone} value={newphone} onKeyDown={handleKeyDownCreate}></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.language")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onChange={updateNewLanguage} value={newlanguage} onKeyDown={handleKeyDownCreate}>
                                <option value="no">{t("users.language_norwegian")}</option>
                                <option value="en">{t("users.language_english")}</option>
                            </Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_invoicinguserid")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_invoicinguserid")} onChange={updateNewInvoicingUserId} value={newInvoicingUserId} onKeyDown={handleKeyDownCreate}></Form.Control>
                        </InputGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClose}>
                            {t("users.cancel_without_save")}
                        </Button>
                        <Button onClick={handleCreateUser}>
                            {t("users.save")}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Edit Modal */}
                <Modal show={showEditModal} onHide={handleCloseEditModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("users.users_edit")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_name")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_name")} onChange={evt => setEditUserName(evt.target.value)} value={editUser["name"]} onKeyDown={handleKeyDownEdit}></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_unit")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onKeyDown={handleKeyDownEdit} onChange={evt => setEditUserUnit((evt.target as HTMLSelectElement).value)} value={editUser["unit"][0]} >
                                {/*<option value="">{t("users.organisation_selected")}</option>*/}
                                {orgs.map((item, key) => {
                                    return (
                                        <option key={key} value={item["_id"]}>{item["name"]}</option>
                                    );
                                })}
                            </Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_role")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onKeyDown={handleKeyDownEdit} onChange={(evt) => setEditUserRole((evt.target as HTMLSelectElement).value)} value={editUser["role"][0]} >
                                <option value="">{t("users.roles_choose")}</option>
                                <option value="Admin">{t("users.admin")}</option>
                                <option value="User">{t("users.user")}</option>
                            </Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_orgrole")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onKeyDown={handleKeyDownEdit} onChange={(evt) => setEditUserOrgRole((evt.target as HTMLSelectElement).value)} value={editUser["orgRole"][0]} >
                                <option value="">{t("users.orgroles_choose")}</option>
                                <option value="cleaningstaff">{t("users.cleaningstaff")}</option>
                                <option value="janitor">{t("users.janitor")}</option>
                                <option value="external">{t("users.external")}</option>
                                {editUser["role"][0] === "Admin" &&
                                    <option value="systemTech">{t("users.systemtech")}</option>
                                }
                            </Form.Control>
                        </InputGroup>
                        { editUser["orgRole"] == "external" ?
                            <React.Fragment>
                                <Field type="selectmulti"
                                    title={t("users.events")}
                                    value={editUser["externalAccess"]?.map(x => { return { value: x, label: events.find(y => y.value == x)?.label }})}
                                    options={{ choices: events }}
                                    onChange={(value) => setEditUserExternalAccess(value.map(x => x.value))}
                                />
                                <p style={{
                                    marginTop: "-16px",
                                    fontSize: "14px",
                                    textAlign: "right"
                                }}>{t("users.events_accesstext")}</p>
                            </React.Fragment>
                        : null }
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_email")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_email")} onKeyDown={handleKeyDownEdit} onChange={evt => setEditUserEmail(evt.target.value)} value={editUser["email"]} ></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_password")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="password" autoComplete="new-password" placeholder={t("users.new_password")} onKeyDown={handleKeyDownEdit} onChange={evt => setEditUserPassword(evt.target.value)} value={editUser["password"]} ></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_mobile")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_mobile")} onKeyDown={handleKeyDownEdit} onChange={evt => setEditUserPhone(evt.target.value)} value={editUser["phone"]} ></Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.language")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control as="select" onKeyDown={handleKeyDownEdit} onChange={evt => setEditUserLanguage((evt.target as HTMLSelectElement).value)} value={editUser["language"]} >
                                <option value="no">{t("users.language_norwegian")}</option>
                                <option value="en">{t("users.language_english")}</option>
                            </Form.Control>
                        </InputGroup>
                        <InputGroup className="mb-3">
                            <InputGroup.Prepend>
                                <InputGroup.Text>{t("users.new_invoicinguserid")}</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control type="text" placeholder={t("users.new_invoicinguserid")} onKeyDown={handleKeyDownEdit} onChange={evt => setEditUserInvoicingUserId(evt.target.value)} value={editUser["invoicingUserId"]} ></Form.Control>
                        </InputGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCloseEditModal}>
                            {t("users.cancel")}
                        </Button>
                        <Button onClick={handleEditUser}>
                            {t("users.save")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {t("users.delete_user")}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{t("users.delete_info")}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleCloseDeleteModal}>
                            {t("users.cancel")}
                        </Button>
                        <Button onClick={handleDeleteUser}>
                            {t("users.delete_user")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
}

export default Users;